export default `
clip-path: url(#leaf-clip-path--right);
`
